// extracted by mini-css-extract-plugin
export default {"mainContainer":"LargeButton_mainContainer__t7c5G","lightBg":"LargeButton_lightBg__CyQ3W","darkBg":"LargeButton_darkBg__wup1c","buttonText":"LargeButton_buttonText__LpZc+"};